<template>
  <div class="level">
    <qd-collapse class="column is-5 is-paddingless" >
      <div class="columns is-multiline is-marginless subMenu">
        <div class="column is-12 is-paddingless">
          <div class="level-right">
            <button @click="close()" class="button is-subMenu">
              <b-icon icon="close"
                      custom-size="mdi-10px"
                      type="is-white">
              </b-icon>
            </button>
          </div>
          <display-menu-and-sub-menu :menuAndSubMenu="getMenuComptabilite">
          </display-menu-and-sub-menu>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import displayMenuAndSubMenu from '@/components/sideBar/submenuSidebar/displayMenuAndSubMenu';
import * as permCompta from '@/configuration/compta/permissionsComptaConf';
import { EXERCICE_COMPTABLE } from '@/configuration/general/permissionsParametrageConf';
import { MOIS_COMPTABLE } from '@/configuration/presse/permissionsPresseConf';
import {
  SET_COMPTA_MENU, SET_INDEX_SUB_MENU_OPEN,
} from '@/store/modules/menu/menu-mutation-type';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Menu = createNamespacedHelpers('menu');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'SidebarComptabilite',
  data() {
    return {
      comptabilite: [],
    };
  },
  components: {
    displayMenuAndSubMenu,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    getMenuComptabilite() {
      return this.comptabilite.filter((menu) => { return menu.isVisible === true; });
    },
  },
  methods: {
    ...Menu.mapMutations({
      setComptaMenu: SET_COMPTA_MENU,
      setIndexSubMenu: SET_INDEX_SUB_MENU_OPEN,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    fillComptabiliteMenu() {
      this.comptabilite = [
        {
          title: 'sidebar.comptabilite.journalEcriture',
          path: 'l.comptabilite.journal_ecriture',
          perm: permCompta.JOURNAL_ECRITURE.lecture,
          noSubMenu: true,
          isVisible: true,
        },
        {
          title: 'sidebar.comptabilite.lotsComptable',
          path: 'l.comptabilite.lots_comptable',
          perm: permCompta.LOTS_COMPTABLE.lecture,
          noSubMenu: true,
          isVisible: true,
        },
        {
          title: 'sidebar.comptabilite.ecritureComptable',
          path: 'l.comptabilite.ecriture_comptable',
          perm: permCompta.ECRITURE_COMPTABLE.lecture,
          noSubMenu: true,
          isVisible: true,
        },
        {
          title: 'sidebar.comptabilite.operationDiverse',
          path: 'l.comptabilite.operation_diverse',
          perm: permCompta.OPERATION_DIVERSE.lecture,
          noSubMenu: true,
          isVisible: true,
        },
        {
          title: 'sidebar.comptabilite.moisComptable',
          path: 'l.presse.mois_comptable',
          perm: MOIS_COMPTABLE.lecture,
          noSubMenu: true,
          isVisible: this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key),
        },
        {
          title: 'sidebar.comptabilite.excercicesComptable',
          path: 'l.parametrage.exercice_comptable',
          perm: EXERCICE_COMPTABLE.lecture,
          noSubMenu: true,
          isVisible: true,
        },
        {
          title: 'sidebar.comptabilite.situation',
          path: 'l.comptabilite.situation',
          perm: permCompta.SITUATION.lecture,
          noSubMenu: true,
          isVisible: true,
        },
      ];
    },
    close() {
      this.setComptaMenu(false);
      this.setIndexSubMenu(null);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      this.fillComptabiliteMenu();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
